<template>
  <div class="w-full lg:w-6/12 xl:w-6/12 flex items-center justify-start relative bg-costeaPrimary">
    <div class="w-full h-full relative">
      <!-- Imagen con gradiente ajustado -->
      <div class="absolute inset-0 h-full w-full ">
        <img :src="LoginImage" class="h-full w-full transform lg:object-cover object-cover object-[50%_20%] "
          alt="Background" />
      </div>

      <!-- Contenedor general del contenido -->
      <div
        class="absolute inset-0 flex flex-col justify-between md:justify-center lg:justify-between p-6 md:p-8 lg:px-16">
        <!-- Logo y redes sociales -->
        <div
          class="flex flex-col md:flex-row justify-center md:justify-between items-center lg:space-y-4 md:space-y-0 md:mb-0 lg:mb-4">
          <!-- Logo -->
          <img class="w-36 md:w-44 lg:w-48 " :src="costea.logo" :alt="costea.logoAlt" />


        </div>

        <!-- Textos principales ocultos en móviles -->
        <div class="hidden lg:block space-y-2 md:space-y-4 text-center md:text-left">
          <h1 class="text-h24 md:text-h32 font-bold text-white">
            ¡Bienvenido a Costea!
          </h1>
          <p class="text-t16 md:text-t18 font-normal text-white">
            La plataforma para la gestión oportuna de los costos de tu empresa.
          </p>
        </div>

        <!-- Redes sociales y versión visibles en pantallas grandes -->
        <div class="space-y-2 text-center md:text-left lg:block hidden">
          <hr class="border-white/50 opacity-75" />
          <p class="text-white text-xs md:text-sm">
            Conoce más de nosotros en nuestras redes.
          </p>
          <div class="flex justify-center md:justify-start space-x-2 md:space-x-4">
            <a href="https://www.linkedin.com/company/costea-co" target="_blank" class="text-white text-xl md:text-2xl">
              <i class="ri-linkedin-box-fill"></i>
            </a>
            <a href="https://www.instagram.com/costea_app/" target="_blank" class="text-white text-xl md:text-2xl">
              <i class="ri-instagram-fill"></i>
            </a>
          </div>
          <p class="text-xs md:text-sm text-white mt-4">v1.1.1</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginImage from '../../assets/img/fondoLogin.png';
export default {
  name: 'Background',
  data() {
    return {
      LoginImage: LoginImage,
      costea: {
        logo: require('../../assets/img/logoBlanco.svg'),
        logoAlt: 'Costea Logo',
      },
    };
  },
};
</script>

<style>
* {
  font-family: 'DM Sans', sans-serif;
}
</style>
